import { makeStyles, Box, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { editBtnAgain } from 'src/store/modules/buttons';
import { editRadius } from 'src/store/modules/imageUpload';

interface radiusProps {
  menuTitle: string;
  type: string;
  max: number;
}

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
  },

  radiusWrapper: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    color: '#191F28',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: '#4E5968'
    }
  },
  radius: {
    width: '20px',
    height: '20px',
    padding: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1.5px solid #E5E8EB',
    borderRadius: '50%',
    transition: 'all 0.2s ease'
  },
  radiusAct: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: '#191F28'
  },

  input: {
    height: '44px',
    padding: '12px',
    outline: 'none',
    overflow: 'hidden',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA',
    '&:focus': {
      borderColor: '#191F28',
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'block'
  },
  inputText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '1.5',
    color: '#191F28'
  }
}));

const EditMultiBtnAgain: any = ({ type, currentIndex, idx }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const handleBtnAgain = e => {
    const newBtnAgain = JSON.parse(JSON.stringify(btnAgain));
    newBtnAgain[type][currentIndex][idx] = e.target.value;
    dispatch(editBtnAgain(newBtnAgain));
  };

  const handleClickInput = (type: any) => {
    if (btnAgain?.type?.[currentIndex]?.[idx] === type) {
      const newBtnAgain = JSON.parse(JSON.stringify(btnAgain));
      newBtnAgain.type[currentIndex][idx] = 'none';
      dispatch(editBtnAgain(newBtnAgain));
    } else {
      const newBtnAgain = JSON.parse(JSON.stringify(btnAgain));
      newBtnAgain.type[currentIndex][idx] = type;
      dispatch(editBtnAgain(newBtnAgain));
    }
  };

  return (
    <div className={classes.root}>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <Box
          className={classes.radiusWrapper}
          onClick={() => handleClickInput('attribute')}
        >
          <Box className={classes.radius}>
            {btnAgain?.type?.[currentIndex]?.[idx] === 'attribute' && (
              <Box className={classes.radiusAct} />
            )}
          </Box>
          <span>Log Custom Attribute</span>
        </Box>
        {btnAgain?.type?.[currentIndex]?.[idx] === 'attribute' && (
          <TextField
            className={classes.input}
            id="standard-multiline-flexible"
            //   multiline
            InputProps={{
              classes: {
                root: classes.inputRoot,
                input: classes.inputText
              },
              disableUnderline: true
            }}
            value={btnAgain?.[type]?.[currentIndex]?.[idx]}
            onChange={handleBtnAgain}
          />
        )}

        <Box
          className={classes.radiusWrapper}
          onClick={() => handleClickInput('event')}
        >
          <Box className={classes.radius}>
            {btnAgain?.type?.[currentIndex]?.[idx] === 'event' && (
              <Box className={classes.radiusAct} />
            )}
          </Box>
          <span>Log Custom Event</span>
        </Box>
        {btnAgain?.type?.[currentIndex]?.[idx] === 'event' && (
          <TextField
            className={classes.input}
            id="standard-multiline-flexible"
            //   multiline
            InputProps={{
              classes: {
                root: classes.inputRoot,
                input: classes.inputText
              },
              disableUnderline: true
            }}
            value={btnAgain?.[type]?.[currentIndex]?.[idx]}
            onChange={handleBtnAgain}
          />
        )}
      </Box>
    </div>
  );
};
export default EditMultiBtnAgain;
